import React, { useState, useContext } from 'react'
import { Box, Text } from "grommet"
import TriageUrlContext from '../../../../context/TriageUrlContext'

import TTJsonTree from '../../../common/TTJsonTree'
import Spinner from '../../../common/Spinner'

import axios from 'axios'

import { gql, useSubscription } from '@apollo/client';

import { TopBar } from '../../TriageViewUtils'
import { useDefaultConf } from '../../TriageHeaders'

const TASK_QUERY = gql`
subscription($taskId: String!) {
    jobtask(where: {taskid: {_eq: $taskId}}) {
        taskid
        result
        status
      }
}
`

const TriageGroupResult = ({ content }) => {

    const [result, setResult] = useState(false)
    const t3_url = useContext(TriageUrlContext)

    const { data: taskResult, loading: taskDataLoading } = useSubscription(
        TASK_QUERY, { variables: { taskId: content.taskid } }
    )
    const axiosConf = useDefaultConf()

    let t3TaskStatus = t3_url + '/api/1/taskstatus/' + content.taskid + '?group=true'

    async function getStatusResponse() {
        const response = await axios(t3TaskStatus, axiosConf)
        setResult(response.data)
    }

    if (!taskDataLoading && taskResult && taskResult.jobtask &&
        taskResult.jobtask.length > 0 && taskResult.jobtask[0].status === 0
        && !(content.taskid.includes("MANUAL")) && !taskResult.jobtask[0].result.length > 0) {
        getStatusResponse()
    }

    return (
        <>
            <Box margin={{ left: '20px', top: '20px', right: '20px', bottom: '20px' }}>
                <Text weight='bold'>Triage Group Response</Text>
                {((content && content.taskid && (content.taskid.includes("MANUAL")) && result) || taskDataLoading) &&
                    <Spinner />
                }

                {result &&
                    <TopBar text={JSON.stringify(result)} />
                }
                <Box height="80%">
                    {!taskDataLoading && content.taskid && taskResult && taskResult.jobtask &&
                        taskResult.jobtask.length > 0 && taskResult.jobtask[0].status &&
                        taskResult.jobtask[0].status !== 0 && !result && taskResult.jobtask[0].result &&
                        // IF MANUAL and Status is not in progress -> Show result from DB
                        <TTJsonTree data={taskResult.jobtask[0].result} expandAll={true} />
                    }

                    {!taskDataLoading && content.taskid && content.taskid.indexOf("MANUAL") === -1 && result &&
                        // IF NOT MANUAL -> Get Result from API
                        <TTJsonTree data={result} expandAll={true} />
                    }
                </Box>
            </Box>
        </>
    )
}

export default TriageGroupResult